module.exports = __webpack_public_path__ + "img/79_3.088ae531.png";